import { memo, useEffect } from "react";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ".././inner.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

function PaediatricOrthopaedics() {
  useEffect(() => {
    document.title = "Paediatric Orthopaedics | Viksha Health Care";
    const newMetaDescription =
      "Paediatric orthopaedics at Viksha Health Care. Assessment of bone and joint problems in children, including growth-related and congenital concerns.";
    const metaTag = document.querySelector('meta[name="description"]');
    if (metaTag) {
      metaTag.setAttribute("content", newMetaDescription);
    }
  }, []);

  return (
    <>
      <h2 style={{ fontSize: "0px" }}>Paediatric Orthopaedics</h2>
      <div className="serinfobox">
        <div className="serinfoimg">
          <LazyLoadImage src="/photo/Paediatric-Orthopaedics.avif" />
        </div>
        <div className="textareaofser">
          <h1>Paediatric Orthopaedics</h1>

          <p>
            Paediatric orthopaedics focuses on bone, joint, and muscle problems
            in infants, children, and adolescents. Growing bones and joints are
            different from adults, so children require specialized evaluation
            and treatment to ensure healthy development.
          </p>

          <p>
            Early diagnosis and appropriate care can prevent long-term
            complications and help children return to normal play, sports, and
            daily activities.
          </p>

          <h5>Common Paediatric Orthopaedic Conditions</h5>
          <ul>
            <li>Congenital deformities present at birth</li>
            <li>Limb alignment issues such as bow legs or knock knees</li>
            <li>Growth-related bone and joint problems</li>
            <li>Paediatric fractures and injuries</li>
            <li>Sports injuries in active children and teenagers</li>
            <li>Joint or muscle infections and inflammations</li>
          </ul>

          <h5>Evaluation and Diagnosis</h5>
          <p>
            A child-friendly approach is used during evaluation. Assessment
            includes a detailed history, physical examination, and when
            necessary, imaging tests to understand the condition while keeping
            the child comfortable.
          </p>

          <h5>Non-Surgical Treatment</h5>
          <p>
            Many paediatric orthopaedic problems can be treated without surgery.
            This may include observation, physiotherapy, braces, splints, or
            casts to guide proper growth and healing.
          </p>

          <h5>Surgical Treatment (When Needed)</h5>
          <p>
            Surgery may be recommended in certain conditions to correct
            deformities or repair injuries. Procedures are carefully planned to
            protect growth plates and support normal bone development.
          </p>

          <h5>Growth Monitoring</h5>
          <p>
            Regular follow-up visits are important to monitor growth and ensure
            that treatment is working effectively. Adjustments are made as the
            child grows.
          </p>

          <h5>When to Consult a Paediatric Orthopaedic Specialist</h5>
          <ul>
            <li>Persistent joint pain or swelling in a child</li>
            <li>Uneven walking or limping</li>
            <li>Visible deformity in limbs or spine</li>
            <li>Delayed walking or movement milestones</li>
            <li>Injuries from sports or falls</li>
          </ul>

          <p>
            Paediatric orthopaedic care aims to support healthy growth, restore
            normal movement, and ensure children can stay active and pain-free
            as they grow.
          </p>
        </div>
      </div>
    </>
  );
}

export default memo(PaediatricOrthopaedics);
